'use client';

import { NextIntlClientProvider } from 'next-intl';
import { ReactNode, useState, useEffect } from 'react';
import { useAuth } from '@/lib/auth/auth-context';
import enMessages from '@/messages/en.json';
import itMessages from '@/messages/it.json';
import esMessages from '@/messages/es.json';
import frMessages from '@/messages/fr.json';
import deMessages from '@/messages/de.json';
import ptMessages from '@/messages/pt.json';
import nlMessages from '@/messages/nl.json';
import ruMessages from '@/messages/ru.json';
import zhMessages from '@/messages/zh.json';
import jaMessages from '@/messages/ja.json';
import koMessages from '@/messages/ko.json';
import arMessages from '@/messages/ar.json';
import hiMessages from '@/messages/hi.json';
import plMessages from '@/messages/pl.json';
import svMessages from '@/messages/sv.json';

const messages: Record<string, any> = {
  en: enMessages,
  it: itMessages,
  es: esMessages,
  fr: frMessages,
  de: deMessages,
  pt: ptMessages,
  nl: nlMessages,
  ru: ruMessages,
  zh: zhMessages,
  ja: jaMessages,
  ko: koMessages,
  ar: arMessages,
  hi: hiMessages,
  pl: plMessages,
  sv: svMessages,
};

export function IntlProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const [locale, setLocale] = useState('en');

  useEffect(() => {
    // Get locale from user profile or localStorage or browser
    if (user?.user_metadata?.preferred_language) {
      setLocale(user.user_metadata.preferred_language);
    } else {
      const savedLocale = localStorage.getItem('locale');
      if (savedLocale && messages[savedLocale]) {
        setLocale(savedLocale);
      } else {
        const browserLang = navigator.language.split('-')[0];
        if (messages[browserLang]) {
          setLocale(browserLang);
        }
      }
    }
  }, [user]);

  return (
    <NextIntlClientProvider locale={locale} messages={messages[locale]}>
      {children}
    </NextIntlClientProvider>
  );
}
